module.exports = __webpack_public_path__ + "static/media/real-time.7ad33e16.jpg";